var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @file Password component
 * @author liyanan19
 */
import OutlinedEyeClose from 'acud-icon/lib/icons/OutlinedEyeClose';
import OutlinedEye from 'acud-icon/lib/icons/OutlinedEye';
import classNames from 'classnames';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import Input from './Input';
import { ConfigContext } from '../config-provider';
const Password = props => {
    const { value: rawValue, defaultValue, prefixCls: customizePrefixCls, visibilityToggle = true, size = 'middle', className, style, disabled, placeholder, onChange, onPressEnter, onKeyDown, onFocus, onBlur } = props, restPorps = __rest(props, ["value", "defaultValue", "prefixCls", "visibilityToggle", "size", "className", "style", "disabled", "placeholder", "onChange", "onPressEnter", "onKeyDown", "onFocus", "onBlur"]);
    const [value, setValue] = useState(rawValue || defaultValue);
    const [type, setType] = useState('password');
    const inputRef = useRef(null);
    useEffect(() => {
        if ('value' in props && value !== props.value) {
            setValue(props.value || '');
            if (props.value === 0) {
                setValue(0);
            }
        }
    }, [props, value, disabled]);
    const handleChange = (e) => {
        if (disabled) {
            return;
        }
        setValue(e.target.value);
        if (onChange) {
            onChange(e);
        }
    };
    const handleKeyDown = (e) => {
        if (onPressEnter && e.key === 'Enter') {
            onPressEnter(e);
            // setValue('');
        }
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    const handleFocus = (e) => {
        if (disabled) {
            return;
        }
        if (onFocus) {
            onFocus(e);
        }
    };
    const handleBlur = (e) => {
        if (disabled) {
            return;
        }
        if (onBlur) {
            onBlur(e);
        }
    };
    const handleIconClick = useCallback(() => {
        if (disabled) {
            return;
        }
        setType(type === 'password' ? 'text' : 'password');
    }, [type, disabled]);
    const handleMouseDown = e => {
        e.preventDefault();
    };
    const handleMouseUp = e => {
        e.preventDefault();
    };
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const inputClassName = classNames(prefixCls, className, {
        [`${prefixCls}-disabled`]: disabled,
    });
    const iconBoxClassname = classNames([`${prefixCls}-outer-icon`], {
        [`${prefixCls}-outer-icon-disabled`]: disabled,
        [`${prefixCls}-outer-icon-sm`]: size === 'small',
        [`${prefixCls}-outer-icon-lg`]: size === 'large',
    });
    const iconClassname = classNames([`${prefixCls}-icon`], {
        [`${prefixCls}-icon-disabled`]: disabled,
    });
    return (<div className={`${prefixCls}-outer`} style={style}>
            {visibilityToggle && (<div className={iconBoxClassname} onClick={handleIconClick} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
                    {type === 'password' ? (<OutlinedEyeClose className={iconClassname}/>) : (<OutlinedEye className={iconClassname}/>)}
                </div>)}
            <Input {...restPorps} ref={inputRef} type={type} value={value} size={size} disabled={disabled} className={inputClassName} onChange={handleChange} onKeyDown={handleKeyDown} onFocus={handleFocus} onBlur={handleBlur} placeholder={placeholder || '请输入密码'}/>
        </div>);
};
export default Password;
